import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape } from '@bibliocommons/bc-prop-types';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';

import accountShape from 'app/shapes/accountShape';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import DigitalHoldForm from './DigitalHoldForm';

export default class DigitalHoldButton extends React.PureComponent {
  renderModal() {
    const { holdActions, handleClose, bib, modalKey, holdsTransactions, digitalFormats, currentAccount } = this.props;

    return (
      <ModalContainer modalKey={modalKey} handleClose={handleClose}>
        <DigitalHoldForm
          bib={bib}
          holdsTransactions={holdsTransactions}
          handleClose={handleClose}
          holdActions={holdActions}
          digitalFormats={digitalFormats}
          currentAccount={currentAccount}
        />
      </ModalContainer>
    );
  }

  render() {
    const { disabled, handleOpen, isLoading } = this.props;

    return (
      <div className="cp-place-hold-button">
        <TransactionalSolidButton block isLoading={isLoading} handleClick={handleOpen} disabled={disabled}>
          <FormattedMessage id="place_hold" />
        </TransactionalSolidButton>
        {this.renderModal()}
      </div>
    );
  }
}

DigitalHoldButton.propTypes = {
  bib: bibShape.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  digitalFormats: ImmutablePropTypes.list,
  currentAccount: accountShape
};
